import { render, staticRenderFns } from "./hiringForm.vue?vue&type=template&id=5e70fff2&"
import script from "./hiringForm.vue?vue&type=script&lang=js&"
export * from "./hiringForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports